module.exports = __webpack_public_path__ + "img/mecanikaswing-baniere.9329062.png";